import MonthlyHistogramContainer from '../../../../components/containers/MonthlyHistogramContainer';
import preloadCustomProps from '../../../utils/preloads/preloadHistogramProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'monthly-histogram',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: MonthlyHistogramContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
